import * as React from 'react';

function SvgRss(props) {
  return (
    <svg
      viewBox="0 0 16 16"
      width={16}
      height={16}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.933 12.4A7.333 7.333 0 003.6 5.067V3.6a8.8 8.8 0 018.8 8.8h-1.467zm-2.533 0a4.8 4.8 0 00-4.8-4.8V6a6.4 6.4 0 016.4 6.4H8.4zm-3.2 0a1.6 1.6 0 110-3.2 1.6 1.6 0 010 3.2zM11.75 2h-7.5A2.25 2.25 0 002 4.25v7.5A2.25 2.25 0 004.25 14h7.5A2.25 2.25 0 0014 11.75v-7.5A2.25 2.25 0 0011.75 2z"
        fill="#999"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgRss;
